import React, { useEffect, useState } from "react";

import { connect } from "react-redux";

import { gridSpacing } from "@utils";

import type { FilterModalProps, SavedView } from "./FilterModalProps";
import SavedViewsTable from "./SavedViewsTable";
import SearchText from "../../SearchText/SearchText";
import Tabs from "../../Tabs/Tabs";

const ViewFilters = (props: FilterModalProps & { username: string }) => {
  const {
    savedFilters,
    openSavedFilter,
    removeFilter,
    updateFilter,
    describeQuery,
    tableLayout,
    username,
  } = props;
  const [currentTab, setCurrentTab] = useState<"myViews" | "allViews">(
    "allViews",
  );
  const [filterValue, setFilterValue] = useState("");

  const matches = (view: SavedView) =>
    view.name.toLowerCase().includes(filterValue.toLowerCase());
  const userFilters = savedFilters.filter(
    (view) => view.created_by_username === username && matches(view),
  );
  const allFilters = savedFilters.filter(
    (view) =>
      (view.public || view.created_by_username === username) && matches(view),
  );

  useEffect(() => {
    if (userFilters.length > 0) {
      setCurrentTab("myViews");
    }
  }, []);

  const tabTitle = (title: string, count: number) =>
    count > 0 ? `${title} (${count})` : title;

  const renderTab = (views: SavedView[]) => (
    <>
      <SearchText
        style={{ width: 325, marginBottom: gridSpacing[3] }}
        onChange={(e) => setFilterValue(e.target.value)}
        value={filterValue}
      />
      <SavedViewsTable
        views={views}
        username={username}
        openSavedFilter={openSavedFilter}
        removeFilter={removeFilter}
        updateFilter={updateFilter}
        describeQuery={describeQuery}
        describeLayout={tableLayout?.describe}
      />
    </>
  );

  return (
    <Tabs
      currentTab={currentTab}
      onSelect={setCurrentTab}
      style={{ margin: 0, paddingBottom: gridSpacing[5] }}
      tabContentStyle={{ padding: 0 }}
    >
      <Tabs.Content
        tabKey="myViews"
        title={tabTitle("My Saved Views", userFilters.length)}
      >
        {renderTab(userFilters)}
      </Tabs.Content>
      <Tabs.Content
        tabKey="allViews"
        title={tabTitle("All Views", allFilters.length)}
      >
        {renderTab(allFilters)}
      </Tabs.Content>
    </Tabs>
  );
};

const mapStateToProps = (state: { main: { user: { username: string } } }) => {
  return {
    username: state.main.user.username,
  };
};

export default connect(mapStateToProps)(ViewFilters);
